import styled from 'styled-components';

import { Card } from '@hivebrite/design-system/Card';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

const UserLaneCardLoader = () => (
  <StyledCard dataTestId="builder-loading-item">
    <CircleSkeleton />
    <Skeleton mb={2} height={24} width={139} />
    <Skeleton mb={2} height={15} width={107} />
    <Skeleton height={15} width={107} />
  </StyledCard>
);

export default UserLaneCardLoader;

const StyledCard = styled(Card).attrs(() => ({
  p: 0,
  mt: 1,
  mb: 2,
  height: { _: 189, l: 173, xl: 201 },
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}))`
  border-radius: ${({ theme }) =>
    `${theme.themeVariables.globalBorderRadius}px`};
`;

const CircleSkeleton = styled(Skeleton).attrs(() => ({
  height: 72,
  width: 72,
  mb: 3,
}))`
  border-radius: 50%;
`;
